import { useSearchParams } from 'react-router-dom';
import { PrototypeRenderer } from '../../components/PrototypeRenderer/PrototypeRenderer';
import { Alert } from '@hotjar/hotsauce';
import { getLogger } from '../../utils/observability';
import { useEffect } from 'react';

export function PrototypeScreen() {
  const [searchParams] = useSearchParams();
  const url = searchParams.get('test_url');
  const logger = getLogger();

  useEffect(() => {
    if (!url) {
      logger.error('PrototypeScreen: Missing Url');
    }
  }, [logger, url]);

  if (!url) {
    return <Alert kind="danger">Error: Missing Url</Alert>;
  }

  return <PrototypeRenderer url={decodeURIComponent(url)} />;
}
